import React, { useState } from 'react';

import { CircularProgress, Container, IconButton, LinearProgress, makeStyles, Menu, MenuItem, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import MenuIcon from '@material-ui/icons/Menu';

import ImageWrapper from '../common/ImageWrapper';
import PdfViewer from '../pdfViewer/PdfViewer';

const useStyles = ({ fullScreen = false }) =>
  makeStyles((theme) => ({
    closeButton: {
      position: 'absolute',
      right: 1,
      top: 1,
      zIndex: 10,
    },
    container: {
      height: '100%',
      margin: 0,
      maxWidth: '100%',
      padding: 0,
      width: '100%',
    },
    contentContainer: {
      backgroundColor: '#444',
      height: '100%',
      maxWidth: fullScreen ? '100%' : 'auto',
      overflow: 'auto',
      [theme.breakpoints.down('sm')]: {
        padding: 0,
      },
    },
    contentGrid: {
      alignItems: 'center',
      height: '100%',
      justifyContent: 'center',
    },
    grid: {
      height: '100%',
    },
    listItemText: {
      wordBreak: 'break-all',
    },
    menuButton: {
      '&:hover': {
        color: theme.palette.primary.main,
      },
      backgroundColor: theme.palette.primary.main,
      borderRadius: '15%',
      color: 'white',
      left: 1,
      position: 'absolute',
      top: 1,
      zIndex: 10,
    },
    progress: {
      bottom: 0,
      height: 1,
      left: 0,
      position: 'absolute',
      width: '100%',
    },
  }));

export default ({ fullScreen = false, resources, onClick, onClose, selectedItem, loading = false, errorMessage = null }) => {
  const classes = useStyles({ fullScreen })();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuClick = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const handleItemClick = (item) => {
    if (onClick) onClick(item);
    setAnchorEl(null);
  };

  return (
    <Container className={classes.container}>
      {resources?.length && (
        <>
          <IconButton aria-controls="simple-menu" aria-haspopup="true" onClick={handleMenuClick} className={classes.menuButton}>
            <MenuIcon enableBackground />
          </IconButton>
          <IconButton aria-label="close" onClick={onClose} className={classes.closeButton}>
            <CloseIcon />
          </IconButton>
          <Menu
            id="simple-menu"
            keepMounted
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            PaperProps={{
              style: {
                maxHeight: 400,
              },
            }}>
            {resources.map((item) => (
              <MenuItem button selected={selectedItem?.uuid === item.uuid} onClick={() => handleItemClick(item)} divider key={item.uuid} className={classes.listItemText}>
                {decodeURIComponent(item.fileName)}
                {selectedItem === item && loading && <LinearProgress className={classes.progress} />}
              </MenuItem>
            ))}
          </Menu>
        </>
      )}
      {loading && <CircularProgress />}
      {!loading && !errorMessage && selectedItem?.type === 'image' && (
        <Container className={classes.contentContainer}>
          <ImageWrapper url={selectedItem.path} />
        </Container>
      )}
      {!loading && !errorMessage && selectedItem?.type === 'pdf' && (
        <Container className={classes.contentContainer}>
          <PdfViewer url={selectedItem.path} />
        </Container>
      )}
      {!loading && errorMessage && (
        <Typography variant="subtitle1" style={{ color: 'red' }}>
          {errorMessage}
        </Typography>
      )}
    </Container>
  );
};
